export function FooterSocialIcons() {
  return (
    <div className="flex items-center gap-3">
      <a
        href="https://www.linkedin.com/company/agentous"
        aria-label="Agentous on LinkedIn"
        target="_blank"
        rel="noreferrer"
        className="hover:border-white/20 flex h-9 w-9 items-center justify-center rounded-[10px] border border-[#ffffff1a] bg-[#ffffff0d] transition-colors"
      >
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          aria-hidden="true"
        >
          <path
            d="M10.6666 5.33398C11.7275 5.33398 12.7449 5.75541 13.4951 6.50556C14.2452 7.2557 14.6666 8.27312 14.6666 9.33398V14.0007H12V9.33398C12 8.98036 11.8595 8.64122 11.6094 8.39118C11.3594 8.14113 11.0202 8.00065 10.6666 8.00065C10.313 8.00065 9.97387 8.14113 9.72382 8.39118C9.47377 8.64122 9.33329 8.98036 9.33329 9.33398V14.0007H6.66663V9.33398C6.66663 8.27312 7.08805 7.2557 7.8382 6.50556C8.58834 5.75541 9.60576 5.33398 10.6666 5.33398Z"
            stroke="#a4a4a4"
            strokeWidth="1.33333"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M4.00004 6H1.33337V14H4.00004V6Z"
            stroke="#a4a4a4"
            strokeWidth="1.33333"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M2.66671 4.00065C3.40309 4.00065 4.00004 3.4037 4.00004 2.66732C4.00004 1.93094 3.40309 1.33398 2.66671 1.33398C1.93033 1.33398 1.33337 1.93094 1.33337 2.66732C1.33337 3.4037 1.93033 4.00065 2.66671 4.00065Z"
            stroke="#a4a4a4"
            strokeWidth="1.33333"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </a>
    </div>
  );
}
